export const NotFoundPage = () => (
  <div className="placeholder">
    <h2>Page not found</h2>
    <p className="muted">The link may be out of date.</p>
  </div>
);
